import { TextField } from 'opensolar-ui'
import PropTypes from 'prop-types'

const ReferenceError = ({ label, error }) => <TextField error disabled label={label} value={error} margin="normal" />

ReferenceError.propTypes = {
  error: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

export default ReferenceError
